import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import HomeSection from './pages/Home'
import SpecialitiesSection from './pages/Specialities'
import TestimonialsSection from './pages/Testimonials'
import AboutSection from './pages/About'
import ContactSection from './pages/Contact'
import CareersSection from './pages/Careers'
import Particles from './components/Particles'

function HomePage() {
  return (
    <>
      <main className="flex-grow relative z-10">
        {/* Home Section */}
        <section id="home">
          <HomeSection />
        </section>

        {/* Specialities Section */}
        <section id="specialities">
          <SpecialitiesSection />
        </section>

        {/* Testimonials Section */}
        <section id="testimonials">
          <TestimonialsSection />
        </section>

        {/* About Section */}
        <section id="about">
          <AboutSection />
        </section>

        {/* Contact Section */}
        <section id="contact">
          <ContactSection />
        </section>
      </main>
    </>
  )
}

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col relative bg-black">
        {/* Global starfield background (fixed, behind all content) */}
        <div className="fixed inset-0 z-0 bg-black pointer-events-none">
          <Particles
            particleColors={['#ffffff', '#f5f7fa', '#e8ecff']}
            particleCount={340}
            particleSpread={11}
            speed={0.07}
            particleBaseSize={90}
            moveParticlesOnHover={true}
            alphaParticles={false}
            disableRotation={false}
            sizeRandomness={0.6}
            cameraDistance={22}
            className="w-full h-full"
          />
        </div>

        <div className="relative z-30">
          <Navbar />
        </div>
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/careers" element={<CareersSection />} />
        </Routes>
        
        <div className="relative z-10">
          <Footer />
        </div>
      </div>
    </Router>
  )
}

export default App
